<template>
  <div id="new_user">
    <dd-header
      :headerType=1
    />
    <div id="container">
      <div class="title">
        <h2>登録情報確認</h2>
    </div>
      <section v-if="isNewCorp">
        <p class="text_size_big bold">企業情報</p>
        <dd-corp-confirm
          :corpForm="corpForm"
          :isEdit="false"
        />
      </section>
      <section>
        <p class="text_size_big bold">ユーザー情報</p>
        <dd-user-confirm
          :userForm="userForm"
          :isEdit="false"
        />
      </section>
      <div id="regist_btn">
        <button type="submit" class="main_btn cancel_btn" @click="reEdit">修正する</button>
        <button type="submit" class="main_btn" @click="newUser">登録する</button>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
// Module
import Header from '../components/common/DcHeader'
import CorpConfirm from '../components/user/CorpConfirm'
import UserConfirm from '../components/user/UserConfirm'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  name: 'RegistUserConfirm',
  components: {
    'dd-header': Header,
    'dd-corp-confirm': CorpConfirm,
    'dd-user-confirm': UserConfirm,
    'dd-loading-modal': LoadingModal
  },
  props: {
  },
  data () {
    return {
      corpForm: {
        corpUserId: '',
        corpName: '',
        corpBranchName: '',
        email: '',
        tel: '',
        fax: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        inviteCode: '',
        requestPayment: ''
      },
      userForm: {
        corpUserId: '',
        corpType: '',
        corpDept: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        email: '',
        infosrc: '',
        recvInfo: '',
        consent: '',
        password: '',
        confirmPassword: ''
      },
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  computed: {
    isNewCorp: function () {
      if (!this.userForm || this.userForm.corpUserId === undefined || this.userForm.corpUserId === '') {
        return true
      }
      return false
    }
  },
  methods: {
    reEdit: function () {
      this.$router.go(-1)
    },
    fetchData: function () {
      this.corpForm = App.getLocalStorage(DC_STORAGE_KEY.CORP_DATA)
      this.userForm = App.getLocalStorage(DC_STORAGE_KEY.USER_DATA)
    },
    newUser: function () {
      this.$refs.loadingModalRef.showModal(true)
      if (this.isNewCorp) {
        let payload = {
          corpType: this.userForm.corpType,
          corpName: this.corpForm.corpName,
          corpBranchName: this.corpForm.corpBranchName,
          corpDept: this.userForm.corpDept,
          userLastName: this.userForm.userLastName,
          userFirstName: this.userForm.userFirstName,
          userLastNameKana: this.userForm.userLastNameKana,
          userFirstNameKana: this.userForm.userFirstNameKana,
          email: this.userForm.email,
          tel: this.corpForm.tel,
          fax: this.corpForm.fax,
          postcd: this.corpForm.postcd,
          state: this.corpForm.state,
          city: this.corpForm.city,
          street: this.corpForm.street,
          infosrc: this.userForm.infosrc,
          inviteCode: this.corpForm.inviteCode,
          requestPayment: this.corpForm.requestPayment,
          recvInfo: this.userForm.recvInfo,
          password: this.userForm.password,
          confirmPassword: this.userForm.confirmPassword
        }
        axios.post(DC_URL.USER + '/new/regist-user', payload)
          .then(response => {
            if (response.data.errorMessage) {
              this.handleErrorMessage(response)
            } else {
              App.removeLocalStorage(DC_STORAGE_KEY.CORP_DATA)
              App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)
              this.$router.push('/mmstyle/user/complete')
            }
            this.$refs.loadingModalRef.showModal(false)
          }).catch(error => {
            this.$refs.loadingModalRef.showModal(false)
            Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          })
      } else {
        let payload = {
          corpUserId: this.userForm.corpUserId,
          corpType: this.userForm.corpType,
          corpDept: this.userForm.corpDept,
          userLastName: this.userForm.userLastName,
          userFirstName: this.userForm.userFirstName,
          userLastNameKana: this.userForm.userLastNameKana,
          userFirstNameKana: this.userForm.userFirstNameKana,
          email: this.userForm.email,
          password: this.userForm.password,
          confirmPassword: this.userForm.confirmPassword,
          infosrc: this.userForm.infosrc,
          recvInfo: this.userForm.recvInfo
        }
        axios.post(DC_URL.USER + '/new/regist-user-account', payload)
          .then(response => {
            if (response.data.errorMessage) {
              this.handleErrorMessage(response)
            } else {
              App.removeLocalStorage(DC_STORAGE_KEY.CORP_DATA)
              App.removeLocalStorage(DC_STORAGE_KEY.USER_DATA)
              this.$router.push('/mmstyle/user/complete')
            }
            this.$refs.loadingModalRef.showModal(false)
          }).catch(error => {
            this.$refs.loadingModalRef.showModal(false)
            Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          })
      }
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/RegistUserConfirm.vue